import React from 'react';
import keycode from 'keycode';
import { Icon } from '@econ/ui-elements';
import GlobalKeyboardShortcuts from '../../../shared/components/GlobalKeyboardShortcuts';
import Mutation from '../../../shared/components/Mutation';
import Agreement from './Agreement';
import AgreementSelector from './Selector';
import './style.css';

interface Props {
    currentAgreement: any;
    otherAgreements: any[];
    refetchAgreements: Function;
    user: any;
    session: any;
}

interface State {
    isOpen: boolean;
}

export default class AgreementDetails extends React.Component<Props, State> {
    state = { isOpen: false };
    node: React.RefObject<any> = React.createRef();

    componentWillUnmount() {
        window.removeEventListener('click', this.onClickOutside);
        window.firebird.removeEventListener('click', this.onClickOutside);
    }

    render() {
        const { currentAgreement, otherAgreements = [], refetchAgreements, user, session } = this.props;
        const { isOpen } = this.state;

        if (user.vismaId || user.isAdministrator) {
            return (
                <GlobalKeyboardShortcuts handlers={{ ',': this.toggle }}>
                    <aside id="agreement_details" ref={this.node}>
                        <Agreement
                            isAdministrator={user.isAdministrator}
                            isDeveloper={currentAgreement.isDeveloper}
                            name={currentAgreement.name}
                            number={currentAgreement.number}
                            onClick={this.toggle}
                            onKeyDown={this.onKeyDown}
                            userId={user.id}>
                            <Icon name={isOpen ? 'arrow-up' : 'arrow-down'} />
                        </Agreement>
                        {isOpen && (
                            <Mutation url="/agreements/switch">
                                {({ mutate }) => (
                                    <AgreementSelector
                                        agreements={otherAgreements}
                                        onChangeAgreement={this.changeAgreement(mutate)}
                                        refetchAgreements={refetchAgreements}
                                        session={session}
                                    />
                                )}
                            </Mutation>
                        )}
                    </aside>
                </GlobalKeyboardShortcuts>
            );
        }

        return (
            <aside id="agreement_details">
                <Agreement
                    isDeveloper={currentAgreement.isDeveloper}
                    name={currentAgreement.name}
                    number={currentAgreement.number}
                    userId={user.id}
                />
            </aside>
        );
    }

    onClickOutside = e => {
        if (this.node.current && !this.node.current.contains(e.target)) {
            this.toggle();
        }
    };

    onKeyDown = event => {
        if (event.keyCode === keycode('space') || event.keyCode === keycode('enter')) {
            this.toggle();
        }
    };

    toggle = () =>
        this.setState(
            state => ({ isOpen: !state.isOpen }),
            () => {
                if (this.state.isOpen) {
                    window.addEventListener('click', this.onClickOutside);
                    window.firebird.addEventListener('click', this.onClickOutside);
                } else {
                    window.removeEventListener('click', this.onClickOutside);
                    window.firebird.removeEventListener('click', this.onClickOutside);
                }
            }
        );

    changeAgreement = mutate => agreement => {
        if (agreement.hasCompany2FaEnforced && this.props.session.hasVismaConnect && !this.props.session.with2Fa) {
            window.top.Econ.modalWithEnforcedJsx('tmpl/popup/visma-connect-missing-2fa');
            return;
        }

        mutate(agreement).then(response => {
            if (response && response.data.redirectUrl) {
                window.location.href = response.data.redirectUrl;
            } else {
                window.location.href = window.location.origin;
            }
        });
    };
}
